import { render } from "./NextReviewChart.vue?vue&type=template&id=34ba1114"
import script from "./NextReviewChart.vue?vue&type=script&lang=js"
export * from "./NextReviewChart.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__